<template>
    <div class="post-wrap page-inner">
         <Title v-if="page">
            <h2 v-html="page.title.rendered"></h2>
        </Title>

        <Content v-if="page">
            <div class="box" v-html="page.content.rendered"></div>
        </Content>

        <Loading v-if="!page" class="static" />
        <RelatedItems v-if="page && page.related_items && page.related_items.length !== 0" :list="page.related_items" />
    </div>
</template>
<script>
import GetPreviewUrl from '@/utils/GetPreviewUrl';
import Title from '@/components/ui/Title.vue';
import Loading from '@/components/Loading.vue';
import Content from '@/components/ui/Content.vue';
import RelatedItems from '@/components/RelatedItems.vue';

export default {
    name: 'page',

    data () {
        return {
            page: false,
        }
    },

    components: {
        Title,
        Loading,
        Content,
        RelatedItems,
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.fetchData(params);
            },
            immediate: true,
        }
    },



    methods: {

        fetchData(params) {
            // console.log(params)
            let slug = params.page_slug;

            this.page = false;
            let api_obj = GetPreviewUrl('pages', slug);
            this.$ajax.get(api_obj.url, api_obj.head).then(res => {
                if (res.data.length === 0) this.$router.replace('/page/404');
                // if (!res.data[0].sections) res.data[0].sections = [];
                document.title = window.globals.site_title + ' — ' + this.$decode(res.data[0].title.rendered);

                // if (res.data[0].sub_pages) this.sub_pages = res.data[0].sub_pages;
                if (res.data[0].parent_page_name) document.body.classList.add('parent-page-' + res.data[0].parent_page_name);
                document.body.classList.add('page-' + res.data[0].slug);
                this.page = res.data[0];
            }).catch(error => {
                this.$router.replace('/page/404');
            });

        },


    },



}
</script>

<style lang="scss">
    .contact-wrap {

        .ui-enter,
        .page-title {
            padding: 0 var(--padding);
        }

        .ui-enter {
            font-size: var(--base-size);

            .columns-container {
                font-size: var(--small-size);
            }
        }

        .col {
            display: flex;
            padding: 0 0 var(--padding-x2);

            & > div {
                width: 50%;
                box-sizing: border-box;
                padding: 0 var(--padding);

                & > h2 {
                    padding: 0 0 var(--padding-50);

                }
            }

            .online-form {
                .is-loading {
                    pointer-events: none;
                    opacity: .3;
                }

                h2 {
                    font-size: var(--large-size);
                    line-height: 1.2;
                    padding: var(--padding-50);
                }

                form {


                    .form-item {
                        box-sizing: border-box;
                        margin: var(--padding-50) 0;
                    }


                    textarea,
                    input[type='text'],
                    input[type='email'] {
                        border: none;
                        border: .1rem solid;
                        background: var(--white);
                        width: 100%;
                        font-size: var(--base-size);
                        padding: .5rem 1rem;
                        box-sizing: border-box;

                        &:focus {
                            outline: none;
                        }

                        &::placeholder {
                            color: var(--font-color);
                        }
                    }

                    textarea {
                        height: 12rem;
                    }

                    .error input {
                        border-color: var(--orange);
                    }

                    input[type='submit'] {
                        line-height: 1;
                        padding: 1.2rem 1rem;
                        position: relative;
                        background: transparent;
                        cursor: pointer;
                        font-size: var(--base-size);
                        width: 100%;
                        box-sizing: border-box;
                        text-align: left;
                        border: none;
                        background: var(--yellow);

                        &:hover {
                            background: var(--font-color);
                            color: var(--white);
                        }
                    }
                }


                .loading,
                .wpcf7-response-output {
                    width: 100%;
                    padding: 0;
                    margin: 0;
                    border: none;
                    padding: 0 var(--padding-50);
                    font-size: var(--small-size);
                }
            }

        }

        .top-content.ui-enter .box  {
            font-size: var(--medium-size);
        }
    }
    
    .list-wrap {

        .ui-enter,
        .page-title {
            padding: 0 var(--padding);
        }

        .ui-enter {
            font-size: var(--base-size);
        }

        .ui-list .current-page {
            display: none;
        }
    }

    .press-wrap {

        .page-title {
            .ui-title {
                padding: 0 var(--padding);
                font-size: var(--medium-size);
            }
        }

        .load-more {
            text-align: center;
            padding: 0 var(--padding) var(--padding-x2);
            min-height: 3rem;

            span {
                cursor: pointer;
            }
        }

    }

    @media only screen and (max-width: 767px) {
        .contact-wrap {



            .ui-enter {
                font-size: var(--base-size);

                .columns-container {
                    font-size: var(--base-size);
                }
            }

            .col {
                display: block;
                padding: 0 0 var(--padding);

                & > div {
                    width: 100%;
                    padding-top: var(--padding);

                }

                .online-form {


                    .is-loading {
                        pointer-events: none;
                        opacity: .3;
                    }


                    form {


                        .form-item {
                            box-sizing: border-box;
                            margin: var(--padding-50) 0;
                        }


                        textarea,
                        input[type='text'],
                        input[type='email'] {
                            padding: 1.5rem;

                        }

                        textarea {
                            height: 22rem;
                        }



                        input[type='submit'] {
                            padding: 3rem;
                        }
                    }


                    .loading,
                    .wpcf7-response-output {
                        font-size: var(--base-size);
                    }
                }

            }

        }
        

        .press-wrap {

            .page-title {
                .ui-title {
                    padding: 0 var(--padding);
                    font-size: var(--medium-size);
                }
            }

            .load-more {
                text-align: center;
                padding: 0 var(--padding) var(--padding-x2);
                min-height: 3rem;

                span {
                    cursor: pointer;
                }
            }

        }
    }
</style>